import React from 'react'

const ExpereoOneLogo = ({ className }) => (
  <img
    className={className}
    src={`${process.env.PUBLIC_URL}/brand/logo-sidebar-v1.png`}
    alt="expereo one Developer Portal V1"
    width="168"
    height="65"
    style={{ maxWidth: '100%', height: 'auto' }}
  />
)

export default ExpereoOneLogo
